export const ADDITIONAL_CHARGE_VOLUME_THRESHOLD_CM3 = 35 * 30 * 30;

export function isAboveAdditionalChargeVolume(volumeCm3: number | null): boolean {
  return volumeCm3 != null && volumeCm3 > ADDITIONAL_CHARGE_VOLUME_THRESHOLD_CM3;
}

export function getPackageSizeWarningState({
  isAboveGuideline,
  isAboveAdditionalChargeThreshold,
  xlShipmentsAuthorised,
}: {
  isAboveGuideline: boolean;
  isAboveAdditionalChargeThreshold: boolean;
  xlShipmentsAuthorised: boolean;
}): { shouldShowConfirmation: boolean; showAdditionalChargeWarning: boolean } {
  const showAdditionalChargeWarning = isAboveAdditionalChargeThreshold && !xlShipmentsAuthorised;
  return {
    shouldShowConfirmation: isAboveGuideline || showAdditionalChargeWarning,
    showAdditionalChargeWarning,
  };
}
